// extracted by mini-css-extract-plugin
export default {"root":"AlertOverlay_root__3lN4D","on":"AlertOverlay_on__3dRZF","title":"AlertOverlay_title__2pbzB","copy":"AlertOverlay_copy__tX7gB","actions":"AlertOverlay_actions__31yh5"};